import { lazy } from '../../shared/deployment';

export const WebinarEvaluation = lazy(() => import('./WebinarEvaluation'));
export const WebinarRegistration = lazy(() => import('./WebinarRegistration'));
